import React from 'react'
import { useParams } from 'react-router-dom'

const withParams = WrappedComponent => {
  return props => {
    const params = useParams()
    const { emergencyContactId } = params

    return (
      <WrappedComponent emergencyContactId={emergencyContactId} {...props} />
    )
  }
}

export default withParams
